export const styles = {
    card: {
        border: "1px solid",
        borderColor: "greyscale.100",
        borderRadius: 2,
        p: 3,
        mt: 1,
        backgroundColor: "background.paper",
        width: "100%"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1
    },
    title: {
        color: "primary.700"
    },
    footer: {
        display: "flex",
        justifyContent: "flex-end",
        mt: 2
    },
    listContainer: {
        height: 420,
        // cancel out the card's own horizontal padding so the list's internal
        // padding lines up its item text with the search field / category chips above
        mx: -3,
        mt: 2,
        width: "auto",
        overflow: "hidden",
        borderTop: ({ palette }) => `1px solid ${palette.greyscale["100"]}`
    },
    searchField: {
        mb: 1,
        width: "100%",
        ".MuiInputBase-input": {
            pl: 0
        }
    }
};
